import { 
    SET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID,
    SET_CATALOG_EQUIPMENT_GRID_DATA,
    SET_CATALOG_MANAGEMENT_GRID_COUNT,
    SET_CATALOG_MANAGEMENT_GRID_DATA,
    SET_CATALOG_STATUS_DROPDOWN,
    SET_CATEGORY_DROPDOWN_LIST,
    SET_DRIVE_TRAIN_DROPDOWN,
    SET_EQ_CLASS_CODE_DROPDOWN,
    SET_FUEL_TYPE_DROPDOWN,
    SET_LENGTH_DROPDOWN_LIST,
    SET_MAKE_DROPDOWN,
    SET_MANUFACTURER_DROPDOWN_LIST,
    SET_MODEL_DROPDOWN_LIST,
    SET_MODEL_YEAR_DROPDOWN,
    SET_SEATING_CAPACITY_DROPDOWN_LIST,
    SET_UPDATED_BY_DROPDOWN_LIST,
    SET_UPFIT_OPTION_DROPDOWN,
    SET_VEHICLE_TYPE_DROPDOWN_LIST,
    SET_MODELS_BASED_ON_MAKE,
    IS_CATALOG_ITEM_SAVED,
    SET_CATALOG_ITEM_BY_ASSET_MODEL_ID,
    SET_CATEGORY2_BASED_ON_CATEGORY,
    SET_CATEGORY_TYPE_BASED_ON_CATEGORY,
    SET_CATALOG_DASHBOARD_EXCEL_DATA,
    IS_SELECTED_VEHICLE_LEVELS_VALID,
    SET_ASSET_TYPE_OPTIONS,
    SET_EQ_CLASS_CODE_EXAMPLE
} from "./CatalogManagementType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_CATALOG_MANAGEMENT_GRID_COUNT:
            return {
                ...state,
                catalogManagementGridCount: action.gridCount,
            };
        case SET_CATALOG_MANAGEMENT_GRID_DATA:
            return {
                ...state,
                catalogManagementGridData: action.gridData,
            };
        case SET_CATALOG_EQUIPMENT_GRID_DATA:
            return {
                ...state,
                catalogEquipmentGridData: action.gridData,
            };
        case SET_UPFIT_OPTION_DROPDOWN:
            return {
                ...state,
                upfitOptionDropdownList: action.data,
            };
        case SET_MAKE_DROPDOWN:
            return {
                ...state,
                makeDropdownList: action.data,
            };
        case SET_MODEL_DROPDOWN_LIST:
            return {
                ...state,
                modelDropdownList: action.data,
            };
        case SET_FUEL_TYPE_DROPDOWN:
            return {
                ...state,
                fuelTypeDropdownList: action.data,
            };
        case SET_EQ_CLASS_CODE_DROPDOWN:
            return {
                ...state,
                eqClassCodeDropdownList: action.data,
            };
        case SET_CATALOG_STATUS_DROPDOWN:
            return {
                ...state,
                catalogStatusDropdownList: action.data,
            };
        case SET_DRIVE_TRAIN_DROPDOWN:
            return {
                ...state,
                driveTrainDropdownList: action.data,
            };
        case SET_MODEL_YEAR_DROPDOWN:
            return {
                ...state,
                modelYearDropdownList: action.data,
            };
        case SET_VEHICLE_TYPE_DROPDOWN_LIST:
            return {
                ...state,
                vehicleTypeDropdownList: action.data,
            };
        case SET_UPDATED_BY_DROPDOWN_LIST:
            return {
                ...state,
                updatedByDropdownList: action.data,
            };
        case SET_ALL_DROP_DOWNS_BASED_ON_SUBTYPE_ID:
            return {
                ...state,
                allDropdownsBySubTypeId: action.allDropdownsBySubTypeId,
            }
        case SET_MANUFACTURER_DROPDOWN_LIST:
            return {
                ...state,
                manufacturerDropdownList: action.data,
            };
        case SET_CATEGORY_DROPDOWN_LIST:
            return {
                ...state,
                categoryDropdownList: action.data,
            };
        case SET_LENGTH_DROPDOWN_LIST:
            return {
                ...state,
                lengthDropdownList: action.data,
            };
        case SET_SEATING_CAPACITY_DROPDOWN_LIST:
            return {
                ...state,
                seatingCapacityDropdownList: action.data,
            };
        case SET_MODELS_BASED_ON_MAKE:
            return {
                ...state,
                modelsListBasedOnMake: action.data,
            };
        case IS_CATALOG_ITEM_SAVED:
            return {
                ...state,
                isCatalogItemSaved: action.flag,
            };
        case SET_CATALOG_ITEM_BY_ASSET_MODEL_ID:
            return {
                ...state,
                catalogItemByAssetModelId: action.catalogItem,
            };
        case SET_CATEGORY2_BASED_ON_CATEGORY:
            return {
                ...state,
                category2ListBasedOnCategory: action.category2List,
            };
        case SET_CATEGORY_TYPE_BASED_ON_CATEGORY:
            return {
                ...state,
                categoryTypeListBasedOnCategory: action.categoryTypeList,
            };
        case SET_CATALOG_DASHBOARD_EXCEL_DATA:
            return {
                ...state,
                catalogDashboardExcelData: action.response,
            };
        case IS_SELECTED_VEHICLE_LEVELS_VALID:
            return {
                ...state,
                isSelectedVehicleLevelValid: action.response,
            };
        case SET_ASSET_TYPE_OPTIONS:
            return {
                ...state,
                assetTypeOptionsList: action.response,
            };
        case SET_EQ_CLASS_CODE_EXAMPLE:
            return {
                ...state,
                eqClassCodeExample: action.response,
            };
        default:
            return state;
    }
};

export {
    reducers
};